import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { frontendMenuService } from '../../services/frontendMenuService';
import {
    FaChevronDown,
    FaChevronRight,
    FaBars,
    FaTimes,
    FaExternalLinkAlt,
    FaHome,
    FaUser,
    FaServicestack,
    FaBuilding,
    FaChartPie,
    FaNewspaper,
    FaExclamationCircle,
    FaQuestionCircle,
    FaEnvelope,
    FaFlag,
    FaTasks,
    FaSitemap,
    FaFileAlt,
    FaHandshake,
    FaGavel,
    FaBook,
    FaBullhorn,
    FaPhoneAlt,
    FaWhatsapp,
    FaMailBulk,
    FaLink,
    FaBalanceScale,
    FaCity,
    FaLandmark,
    FaMoneyBillWave,
    FaCalculator,
    FaClipboardList,
    FaListUl,
    FaClock,
    FaKey,
    FaBan,
    FaExclamationTriangle,
    FaFolder,
    FaFile
} from 'react-icons/fa';

// Icon mapping dari string ke komponen
const iconMap = {
    'FaHome': FaHome,
    'FaUser': FaUser,
    'FaServicestack': FaServicestack,
    'FaBuilding': FaBuilding,
    'FaChartPie': FaChartPie,
    'FaNewspaper': FaNewspaper,
    'FaExclamationCircle': FaExclamationCircle,
    'FaQuestionCircle': FaQuestionCircle,
    'FaPhoneAlt': FaPhoneAlt,
    'FaFlag': FaFlag,
    'FaTasks': FaTasks,
    'FaSitemap': FaSitemap,
    'FaFileAlt': FaFileAlt,
    'FaHandshake': FaHandshake,
    'FaMoneyBillWave': FaMoneyBillWave,
    'FaCalculator': FaCalculator,
    'FaClipboardList': FaClipboardList,
    'FaBook': FaBook,
    'FaBullhorn': FaBullhorn,
    'FaGavel': FaGavel,
    'FaLink': FaLink,
    'FaBalanceScale': FaBalanceScale,
    'FaCity': FaCity,
    'FaLandmark': FaLandmark,
    'FaWhatsapp': FaWhatsapp,
    'FaMailBulk': FaMailBulk,
    'FaKey': FaKey,
    'FaBan': FaBan,
    'FaExclamationTriangle': FaExclamationTriangle,
    'FaFolder': FaFolder,
    'FaFile': FaFile,
    'FaEnvelope': FaEnvelope,
    'FaListUl': FaListUl,
    'FaClock': FaClock,
};

const Navbar = () => {
    const [activeMenu, setActiveMenu] = useState(null);       // top-level dropdown
    const [openNested, setOpenNested] = useState(null);       // nested submenu (key: `${parentKey}-${index}`)
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [openSubmenu, setOpenSubmenu] = useState(null);
    const [menuItems, setMenuItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const navbarRef = useRef(null);
    const location = useLocation();

    // Load menu dinamis dari API
    useEffect(() => {
        loadMenus();
    }, []);

    const loadMenus = async () => {
        setLoading(true);
        const result = await frontendMenuService.getPublicMenus();
        if (result.success && result.data) {
            setMenuItems(result.data);
        }
        setLoading(false);
    };

    // Tutup menu saat navigasi
    useEffect(() => {
        setActiveMenu(null);
        setOpenNested(null);
        setOpenSubmenu(null);
        setMobileMenuOpen(false);
    }, [location]);

    // Klik di luar navbar menutup dropdown
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (navbarRef.current && !navbarRef.current.contains(event.target)) {
                setActiveMenu(null);
                setOpenNested(null);
                setOpenSubmenu(null);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleMenuClick = (index, hasSubmenu, event) => {
        if (hasSubmenu) {
            event.preventDefault();
            setActiveMenu(activeMenu === index ? null : index);
            setOpenNested(null);
        }
    };

    const handleSubmenuClick = (event) => {
        event.stopPropagation();
    };

    // Toggle nested submenu
    const toggleNested = (key, event) => {
        event.preventDefault();
        event.stopPropagation();
        setOpenNested(openNested === key ? null : key);
    };

    // Fungsi untuk mendapatkan icon component dari string
    const getIconComponent = (iconName) => {
        return iconMap[iconName] || FaFile;
    };

    // Cek apakah menu atau anaknya aktif berdasarkan path saat ini
    const isMenuActive = (item) => {
        if (item.route && location.pathname === item.route) return true;

        if (item.children) {
            for (const child of item.children) {
                if (child.route && location.pathname === child.route) return true;
                if (child.children) {
                    for (const grandChild of child.children) {
                        if (grandChild.route && location.pathname === grandChild.route)
                            return true;
                    }
                }
            }
        }
        return false;
    };

    // ✅ Render item submenu (desktop) — mendukung nested ke samping
    {/*const renderDesktopSubmenuItem = (item, parentKey, index, onClose) => {
        const Icon = getIconComponent(item.icon);
        const isExternal = item.type === 'external' && item.external_url;
        const hasChildren = item.children && item.children.length > 0;
        const isGroup = item.type === 'group';
        const link = item.external_url || item.route || '#';
        const isActive = isMenuActive(item);
        const nestedKey = `${parentKey}-${index}`;
        const isNestedOpen = openNested === nestedKey;

        const baseClass = `flex items-center justify-between w-full px-3 py-2 text-sm rounded transition-colors duration-200 ${isActive
                ? 'text-yellow-300 font-semibold bg-white/10'
                : 'text-white hover:bg-white/20'
            }`;

        if (isGroup && hasChildren) {
            return (
                <div className="relative" key={nestedKey}>
                    <div className="flex items-center px-3 py-2 text-[11px] font-bold uppercase tracking-wider text-white/70 border-b border-white/20">
                        <Icon className="mr-2 text-xs shrink-0" />
                        {item.name}
                    </div>
                    <div className="mt-1 space-y-0.5 pl-1">
                        {item.children.map((child, idx) => (
                            <div key={`${nestedKey}-${idx}`}>
                                {renderDesktopSubmenuItem(
                                    child,
                                    nestedKey,
                                    idx,
                                    onClose
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            );
        }

        if (hasChildren) {
            return (
                <div className="relative group" key={nestedKey}>
                    <button
                        type="button"
                        onClick={(e) => toggleNested(nestedKey, e)}
                        className={`${baseClass} cursor-pointer`}
                    >
                        <span className="flex items-center">
                            <Icon className="mr-2 text-xs shrink-0" />
                            <span className="text-left">{item.name}</span>
                        </span>
                        <FaChevronRight
                            className={`ml-2 text-[10px] transition-transform duration-200 ${isNestedOpen ? 'rotate-90' : ''
                                }`}
                        />
                    </button>

                    {isNestedOpen && (
                        <div
                            className="absolute left-full top-0 ml-1 min-w-[240px] w-max max-w-[360px] bg-[#229B91] shadow-2xl rounded-lg z-[60] max-h-[80vh] overflow-y-auto py-2"
                            onClick={handleSubmenuClick}
                        >
                            <div className="px-2 space-y-0.5">
                                {item.children.map((child, idx) => (
                                    <div key={child.id || idx}>
                                        {renderDesktopSubmenuItem(
                                            child,
                                            nestedKey,
                                            idx,
                                            onClose
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            );
        }

        if (isExternal) {
            return (
                <Link
                    key={nestedKey}
                    to={`/layanan/redirect/${item.slug}`}
                    className={baseClass}
                    onClick={onClose}
                >
                    <span className="flex items-center">
                        <Icon className="mr-2 text-xs shrink-0" />
                        <span className="text-left">{item.name}</span>
                    </span>
                    <FaExternalLinkAlt className="ml-2 text-xs opacity-70 shrink-0" />
                </Link>
            );
        }

        if (link && link !== '#') {
            return (
                <Link
                    key={nestedKey}
                    to={link}
                    className={baseClass}
                    onClick={onClose}
                >
                    <span className="flex items-center">
                        <Icon className="mr-2 text-xs shrink-0" />
                        <span className="text-left">{item.name}</span>
                    </span>
                </Link>
            );
        }

        return (
            <div
                key={nestedKey}
                className={`flex items-center px-3 py-2 text-sm font-semibold ${isActive ? 'text-yellow-300' : 'text-white/90'
                    }`}
            >
                <Icon className="mr-2 text-xs shrink-0" />
                {item.name}
            </div>
        );
    };*/}

    // ✅ Render item submenu (desktop) — group & nested ke samping
    const renderDesktopSubmenuItem = (item, parentKey, index, onClose) => {
        const Icon = getIconComponent(item.icon);
        const isExternal = item.type === 'external' && item.external_url;
        const hasChildren = item.children && item.children.length > 0;
        const isGroup = item.type === 'group';
        const link = item.external_url || item.route || '#';
        const isActive = isMenuActive(item);
        const nestedKey = `${parentKey}-${index}`;
        const isNestedOpen = openNested === nestedKey;

        const baseClass = `flex items-center justify-between w-full px-3 py-2 text-sm rounded transition-colors duration-200 ${isActive
                ? 'text-yellow-300 font-semibold bg-white/10'
                : 'text-white hover:bg-white/20'
            }`;

        // ===== GROUP ATAU ITEM DENGAN CHILDREN → NESTED KE SAMPING =====
        if (hasChildren) {
            return (
                <div className="relative" key={nestedKey}>
                    <button
                        type="button"
                        onClick={(e) => toggleNested(nestedKey, e)}
                        className={`${baseClass} cursor-pointer ${isGroup ? 'font-semibold' : ''
                            }`}
                    >
                        <span className="flex items-center">
                            <Icon className="mr-2 text-xs shrink-0" />
                            <span className="text-left">{item.name}</span>
                        </span>
                        <FaChevronRight
                            className={`ml-2 text-[10px] transition-transform duration-200 ${isNestedOpen ? 'rotate-90' : ''
                                }`}
                        />
                    </button>

                    {/* ✅ Submenu ke SAMPING kanan */}
                    {isNestedOpen && (
                        <div
                            className="absolute left-full top-0 ml-1 min-w-[240px] w-max max-w-[360px] bg-[#229B91] shadow-2xl rounded-lg z-[60] max-h-[80vh] overflow-y-auto py-2"
                            onClick={handleSubmenuClick}
                        >
                            <div className="px-2 space-y-0.5">
                                {item.children.map((child, idx) => (
                                    <div key={child.id || idx}>
                                        {renderDesktopSubmenuItem(
                                            child,
                                            nestedKey,
                                            idx,
                                            onClose
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            );
        }

        // ===== EXTERNAL LINK =====
        if (isExternal) {
            return (
                <Link
                    key={nestedKey}
                    to={`/layanan/redirect/${item.slug}`}
                    className={baseClass}
                    onClick={onClose}
                >
                    <span className="flex items-center">
                        <Icon className="mr-2 text-xs shrink-0" />
                        <span className="text-left">{item.name}</span>
                    </span>
                    <FaExternalLinkAlt className="ml-2 text-xs opacity-70 shrink-0" />
                </Link>
            );
        }

        // ===== INTERNAL LINK =====
        if (link && link !== '#') {
            return (
                <Link
                    key={nestedKey}
                    to={link}
                    className={baseClass}
                    onClick={onClose}
                >
                    <span className="flex items-center">
                        <Icon className="mr-2 text-xs shrink-0" />
                        <span className="text-left">{item.name}</span>
                    </span>
                </Link>
            );
        }

        // ===== FALLBACK HEADING =====
        return (
            <div
                key={nestedKey}
                className={`flex items-center px-3 py-2 text-sm font-semibold ${isActive ? 'text-yellow-300' : 'text-white/90'
                    }`}
            >
                <Icon className="mr-2 text-xs shrink-0" />
                {item.name}
            </div>
        );
    };

    // ✅ Render item submenu (mobile) — nested ke bawah dengan indentasi
    const renderMobileSubmenuItem = (item, level = 0, onClose) => {
        const Icon = getIconComponent(item.icon);
        const isExternal = item.type === 'external' && item.external_url;
        const hasChildren = item.children && item.children.length > 0;
        const isGroup = item.type === 'group';
        const link = item.external_url || item.route || '#';
        const isActive = isMenuActive(item);

        const paddingLeft = 12 + level * 16;

        const baseClass = `flex items-center w-full py-2 pr-3 text-sm rounded transition-colors duration-200 ${isActive ? 'text-yellow-300 font-semibold bg-white/10' : 'text-white hover:bg-white/20'
            }`;

        if (isGroup && hasChildren) {
            return (
                <div className="mb-1">
                    <div
                        className="flex items-center py-2 pr-3 text-[11px] font-bold uppercase tracking-wider text-white/70 border-b border-white/20"
                        style={{ paddingLeft: `${paddingLeft}px` }}
                    >
                        <Icon className="mr-2 text-xs shrink-0" />
                        {item.name}
                    </div>
                    <div className="mt-1 space-y-0.5">
                        {item.children.map((child, idx) => (
                            <div key={child.id || idx}>
                                {renderMobileSubmenuItem(child, level + 1, onClose)}
                            </div>
                        ))}
                    </div>
                </div>
            );
        }

        if (hasChildren) {
            return (
                <div>
                    <div
                        className="flex items-center py-2 pr-3 text-sm text-white/80 font-medium"
                        style={{ paddingLeft: `${paddingLeft}px` }}
                    >
                        <Icon className="mr-2 text-xs shrink-0" />
                        {item.name}
                    </div>
                    <div className="space-y-0.5">
                        {item.children.map((child, idx) => (
                            <div key={child.id || idx}>
                                {renderMobileSubmenuItem(child, level + 1, onClose)}
                            </div>
                        ))}
                    </div>
                </div>
            );
        }

        if (isExternal) {
            return (
                <Link
                    to={`/layanan/redirect/${item.slug}`}
                    className={baseClass}
                    style={{ paddingLeft: `${paddingLeft}px` }}
                    onClick={onClose}
                >
                    <Icon className="mr-2 text-xs shrink-0" />
                    <span className="flex-1 text-left">{item.name}</span>
                    <FaExternalLinkAlt className="ml-1 text-xs opacity-70 shrink-0" />
                </Link>
            );
        }

        if (link && link !== '#') {
            return (
                <Link
                    to={link}
                    className={baseClass}
                    style={{ paddingLeft: `${paddingLeft}px` }}
                    onClick={onClose}
                >
                    <Icon className="mr-2 text-xs shrink-0" />
                    <span className="flex-1 text-left">{item.name}</span>
                </Link>
            );
        }

        return (
            <div
                className={`flex items-center py-2 pr-3 text-sm font-semibold ${isActive ? 'text-yellow-300' : 'text-white/90'
                    }`}
                style={{ paddingLeft: `${paddingLeft}px` }}
            >
                <Icon className="mr-2 text-xs shrink-0" />
                {item.name}
            </div>
        );
    };

    if (loading) {
        return (
            <nav className="bg-[#229B91] sticky top-0 z-50 shadow-lg">
                <div className="container mx-auto px-4 py-3 text-center text-white text-sm">
                    Memuat menu...
                </div>
            </nav>
        );
    }

    return (
        <nav ref={navbarRef} className="bg-[#229B91] sticky top-0 z-50 shadow-lg">
            <div className="container mx-auto px-4">
                {/* ================= MOBILE HEADER ================= */}
                <div className="flex justify-between items-center py-3 md:hidden">
                    <Link to="/" className="text-white font-bold">
                        BPKAD Magelang
                    </Link>
                    <button
                        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                        className="text-white p-2"
                        aria-label="Toggle menu"
                    >
                        {mobileMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
                    </button>
                </div>

                {/* ================= DESKTOP MENU (horizontal) ================= */}
                <div className="hidden md:flex justify-center items-center flex-wrap">
                    {menuItems.map((item, index) => {
                        const Icon = getIconComponent(item.icon);
                        const hasChildren = item.children && item.children.length > 0;
                        const isGroup = item.type === 'group';
                        const link = item.external_url || item.route || '#';
                        const isExternal = item.type === 'external';
                        const isActive = isMenuActive(item);

                        const baseClass = `flex items-center px-4 py-3 transition-colors duration-200 whitespace-nowrap text-sm cursor-pointer ${isActive ? 'text-yellow-300 font-semibold' : 'text-white hover:bg-white/10'
                            }`;

                        return (
                            <div key={item.id || index} className="relative">
                                {hasChildren || isGroup ? (
                                    <>
                                        <button
                                            onClick={(e) => handleMenuClick(index, true, e)}
                                            className={baseClass}
                                        >
                                            <Icon className="mr-1 text-xs" />
                                            {item.name}
                                            <FaChevronDown
                                                className={`ml-1 text-xs transition-transform duration-200 ${activeMenu === index ? 'rotate-180' : ''
                                                    }`}
                                            />
                                        </button>

                                        {/* ✅ Dropdown Level 2 (turun ke bawah) */}
                                        {activeMenu === index && (
                                            <div
                                                className="absolute left-0 top-full mt-0 min-w-[260px] w-max max-w-[380px] bg-[#229B91] shadow-2xl rounded-b-lg z-50 max-h-[80vh] overflow-visible py-2"
                                                onClick={handleSubmenuClick}
                                            >
                                                <div className="px-2 space-y-0.5">
                                                    {item.children.map((child, childIndex) => (
                                                        <div key={child.id || childIndex}>
                                                            {renderDesktopSubmenuItem(
                                                                child,
                                                                `top-${index}`,
                                                                childIndex,
                                                                () => setActiveMenu(null)
                                                            )}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </>
                                ) : isExternal ? (
                                    <Link
                                        to={`/layanan/redirect/${item.slug}`}
                                        className={baseClass}
                                    >
                                        <Icon className="mr-1 text-xs" />
                                        {item.name}
                                        <FaExternalLinkAlt className="ml-1 text-xs opacity-70" />
                                    </Link>
                                ) : (
                                    <Link to={link} className={baseClass}>
                                        <Icon className="mr-1 text-xs" />
                                        {item.name}
                                    </Link>
                                )}
                            </div>
                        );
                    })}
                </div>

                {/* ================= MOBILE MENU ================= */}
                {mobileMenuOpen && (
                    <div className="md:hidden bg-[#229B91] pb-4">
                        {menuItems.map((item, index) => {
                            const Icon = getIconComponent(item.icon);
                            const hasChildren = item.children && item.children.length > 0;
                            const isGroup = item.type === 'group';
                            const link = item.external_url || item.route || '#';
                            const isExternal = item.type === 'external';
                            const isActive = isMenuActive(item);

                            const baseClassMobile = `flex items-center w-full px-4 py-3 text-sm ${isActive ? 'text-yellow-300 font-semibold' : 'text-white'
                                }`;

                            return (
                                <div
                                    key={item.id || index}
                                    className="border-t border-white/10"
                                >
                                    {hasChildren || isGroup ? (
                                        <div>
                                            <button
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setOpenSubmenu(
                                                        openSubmenu === index ? null : index
                                                    );
                                                }}
                                                className="flex items-center justify-between w-full px-4 py-3 text-sm text-white"
                                            >
                                                <span
                                                    className={`flex items-center ${isActive
                                                            ? 'text-yellow-300 font-semibold'
                                                            : ''
                                                        }`}
                                                >
                                                    <Icon className="mr-2 text-xs" />
                                                    {item.name}
                                                </span>
                                                <FaChevronDown
                                                    className={`transform transition-transform ${openSubmenu === index
                                                            ? 'rotate-180'
                                                            : ''
                                                        }`}
                                                />
                                            </button>

                                            {/* ✅ Submenu mobile (nested ke bawah) */}
                                            {openSubmenu === index && (
                                                <div className="bg-[#1e857d] px-2 py-2 space-y-0.5">
                                                    {item.children.map(
                                                        (child, childIndex) => (
                                                            <div
                                                                key={
                                                                    child.id ||
                                                                    childIndex
                                                                }
                                                            >
                                                                {renderMobileSubmenuItem(
                                                                    child,
                                                                    0,
                                                                    () => {
                                                                        setMobileMenuOpen(
                                                                            false
                                                                        );
                                                                        setOpenSubmenu(
                                                                            null
                                                                        );
                                                                    }
                                                                )}
                                                            </div>
                                                        )
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    ) : isExternal ? (
                                        <Link
                                            to={`/layanan/redirect/${item.slug}`}
                                            className={baseClassMobile}
                                            onClick={() => setMobileMenuOpen(false)}
                                        >
                                            <Icon className="mr-2 text-xs" />
                                            {item.name}
                                            <FaExternalLinkAlt className="ml-1 text-xs opacity-70" />
                                        </Link>
                                    ) : (
                                        <Link
                                            to={link}
                                            className={baseClassMobile}
                                            onClick={() => setMobileMenuOpen(false)}
                                        >
                                            <Icon className="mr-2 text-xs" />
                                            {item.name}
                                        </Link>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </nav>
    );
};

export default Navbar;